import React, {Component} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Validation from "@irati/utils/validation"
import {Input} from "@irati/ui/src/FormItem"
import {FormatMessage} from "@irati/utils/lang/types"

import {StyledFormGroup, StyledIconTooltip} from "./styled"

interface Props extends InjectIntl {
  onChange: (value: string) => void
  value: string
}

const schema = (formatMessage: FormatMessage) =>
  Validation.string(formatMessage({id: "platform.defaultValidation.required"})).url(
    formatMessage({id: "platform.defaultValidation.required"})
  )

class CompanyNewsVideoUrlInput extends Component<Props> {
  render() {
    const {formatMessage, onChange, value} = this.props
    return (
      <StyledFormGroup>
        <Input
          label={
            <>
              <FormattedMessage id="platform.homepage.fields.videoUrl.title" />
              <StyledIconTooltip placement="bottom">
                <FormattedMessage id="platform.homepage.fields.videoUrl.tooltip" />
              </StyledIconTooltip>
            </>
          }
          name="url"
          onChange={onChange}
          placeholder={formatMessage({id: "platform.homepage.fields.videoUrl.placeholder"})}
          type="text"
          validation={schema(formatMessage)}
          value={value}
        />
      </StyledFormGroup>
    )
  }
}

export default injectIntl(CompanyNewsVideoUrlInput)
